import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ProjectCard from "./Projects/ProjectCard";
import projectsData from "../config";

const Projects = () => {
  return (
    <div className="flex flex-col cscroll min-w-[280px] select-none h-[85vh] sx:h-max overflow-y-scroll transition-all duration-300  rounded-xl p-4 px-6 flex-grow">
      <div className="font-bold font-poppins text-2xl sx:text-xl">Projects</div>
      <div className="flex flex-wrap justify-center gap-5">
        {projectsData.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.5, duration:0.7 }}
          >
            <ProjectCard details={project.detailOnCard} projectName={project.projectName} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
